<template>
  <div v-if="taxFilingDetail">
    <div class="header">报税信息</div>
    <div class="detail" >
      <p>公司名称: {{ taxFilingDetail.companyName }}</p>
      <p>申报周期: {{ taxFilingDetail.period }}</p>
      <p>申报类型: {{ taxFilingDetail.type }}</p>
      <p>申报月份: {{ taxFilingDetail.month }}</p>
      <p>增值税: <span class="currency">{{ taxFilingDetail.r10?'￥'+taxFilingDetail.r10:'' }}</span></p>
      <p>请输入城市维护建设税: <span class="currency">{{ taxFilingDetail.r21?'￥'+taxFilingDetail.r21:'' }}</span></p>
      <p>地方教育附加税: <span class="currency">{{ taxFilingDetail.r22?'￥'+taxFilingDetail.r22:'' }}</span></p>
      <p>教育附加税: <span class="currency">{{ taxFilingDetail.r23?'￥'+taxFilingDetail.r23:'' }}</span></p>
      <p>其他行政事业型收费收入: <span class="currency">{{ taxFilingDetail.r24?'￥'+taxFilingDetail.r24:'' }}</span></p>
      <p>个人所得税: <span class="currency">{{ taxFilingDetail.r31?'￥'+taxFilingDetail.r31:'' }}</span></p>
      <p>企业所得税: <span class="currency">{{ taxFilingDetail.r32?'￥'+taxFilingDetail.r32:'' }}</span></p>
      <p>印花税: <span class="currency">{{ taxFilingDetail.r40?'￥'+taxFilingDetail.r40:'' }}</span></p>
      <p>工会经费: <span class="currency">{{ taxFilingDetail.r50?'￥'+taxFilingDetail.r50:'' }}</span></p>
    </div>
    <div class="header">附件</div>
    <div class="detail">
      <p>国税:<a v-if="taxFilingDetail.d60InternalName" :href="url60">查看</a></p>
      <p>个税:<a v-if="taxFilingDetail.d31InternalName" :href="url31">查看</a></p>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: "TaxFilingDetail",
    computed:{
      ...mapGetters(['taxFilingDetail']),
      id(){
        return this.$route.params.taxFilingId
      },
      url60(){
        let type = '';
        if(this.taxFilingDetail.d60FileName){
          let type = '';
          let index = this.taxFilingDetail.d60FileName.lastIndexOf(".");
          let suffix = this.taxFilingDetail.d60FileName.substr(index + 1);

          if (suffix === 'jpg' || suffix === 'jpeg') {
            type = 'image';
          } else if (suffix === 'xls' || suffix === 'xlsx') {
            type = 'excel'
          } else if (suffix === 'pdf') {
            type = 'pdf';
          }
          //return `/preview.html?id=${this.taxFilingDetail.d60InternalName}&isPic=${isPic}`;
          return `/preview.html?type=${type}&url=${process.env.VUE_APP_API}assets/${this.taxFilingDetail.d60InternalName}`;
        }else{
          return '';
        }
      },
      url31(){
        let type = '';
        if(this.taxFilingDetail.d31FileName){
          if(this.taxFilingDetail.d31FileName.indexOf('jpg') > -1 || this.taxFilingDetail.d31FileName.indexOf('jpeg') > -1){
            type='image';
          }else{
            type = 'pdf';
          }
          //return `/preview.html?id=${this.taxFilingDetail.d31InternalName}&isPic=${isPic}`;
          return `/preview.html?type=${type}&url=${process.env.VUE_APP_API}assets/${this.taxFilingDetail.d31InternalName}`;
        }else{
          return '';
        }
      },
    },
    methods:{
      ...mapActions(['getTaxFilingDetail']),
    },
    created() {
      this.getTaxFilingDetail(this.id);
    }
  }
</script>

<style scoped>
  .header{
    background: #F2F2F2;
    height: 40px;
    padding:0 26px;
    line-height: 40px;
    font-size: 14px;
    font-weight: bold;
  }
  .detail{
    padding:10px 26px;
    font-size: 14px;
    line-height: 28px;
  }
  .detail .title{
    font-size: 16px;
    font-weight: bold;
  }
  .detail .currency{
    font-size: 18px;
    color:#FD493A;
  }
</style>
